<template>
  <hm-content title="活动详情">
    <div class="detail-container">
      <div class="activity mb20">
        <div class="caption">基础信息</div>
        <ul>
          <li class="flex">
            <div class="title">活动名称：</div>
            <div class="content">{{ activityListDetails.actName }}</div>
          </li>
          <li class="flex">
            <div class="title">活动日期：</div>
            <div class="content">
              {{
                activityListDetails.actStartTime
                  ? activityListDetails.actStartTime.split(" ")[0]
                  : ""
              }}
              至
              {{
                activityListDetails.actEndTime
                  ? activityListDetails.actEndTime.split(" ")[0]
                  : ""
              }}
            </div>
          </li>
          <li class="flex">
            <div class="title">报名时间：</div>
            <div class="content">
              {{ activityListDetails.applyStartTime }} 至
              {{ activityListDetails.applyEndTime }}
            </div>
          </li>
          <li class="flex">
            <div class="title">活动地点：</div>
            <div class="content">{{ activityListDetails.actSite }}</div>
          </li>
          <li class="flex">
            <div class="title">适合人群：</div>
            <div class="content">{{ activityListDetails.suitPerson }}</div>
          </li>
          <li class="flex">
            <div class="title">报名情况：</div>
            <div class="content">
              {{ activityListDetails.realApplyNum || 0 }} /
              {{ activityListDetails.actMemberUpperLimit }} 人
            </div>
          </li>
          <li class="flex">
            <div class="title">活动状态：</div>
            <div class="content">
              <span v-if="activityListDetails.actStatus == 1" class="success"
                >开启</span
              >
              <span v-if="activityListDetails.actStatus == 0" class="danger"
                >关闭</span
              >
            </div>
          </li>
          <li class="flex">
            <div class="title">活动网址：</div>
            <div class="content flex-1">
              <span style="word-break: break-all;">
                {{ activityAddress }}
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="activity mb20">
        <div class="caption">报名场次</div>
        <ul>
          <li
            class="mb20 borderB"
            v-for="(item, index) in activityListDetails.roundBo"
            :key="index"
          >
            <div class="title mb20">活动地点:{{ item.actSite }}</div>
            <ul class="content">
              <li
                class="flex"
                v-for="(i, index) in item.subscribeRound"
                :key="index"
              >
                <div class="mr10">活动场次：{{ i.actRound }}</div>
                <div class="mr10">活动费用：{{ i.actCostMoney }}元</div>
                <div class="mr10">活动积分：{{ i.actCostIntegral }}积分</div>
                <div class="mr10">
                  场次报名情况：{{ i.registeredAmount }} /
                  {{ i.onceActMemberUpperLimit }}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="activity mb20">
        <div class="caption">活动宣传图</div>
        <ul>
          <li class="flex">
            <div class="title">主图：</div>
            <div class="content flex-1">
              <img :src="activityListDetails.mainImgUrl" alt />
            </div>
          </li>
          <li class="flex">
            <div class="title">轮播图：</div>
            <div class="content flex-1">
              <div
                v-for="(item, index) in activityListDetails.subscribeCarousel"
                :key="index"
              >
                <img :src="item.carouselImgUrl" alt />
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">活动详情：</div>
            <div class="content flex-1">
              <div class="ql-container ql-snow">
                <div class="ql-editor">
                  <div v-html="activityListDetails.actDesc"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-wrapper flex flex-center">
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('audit_pass')"
        >通过</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('reject')"
        >驳回</el-button
      >
      <el-button size="small" @click="back">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
 
import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
 export default {
    
  data() {
    return {
      mode: "",
      previewDiaogVisible: false,
      keyWord: "",
      discountMode: "",
      storeOutletId: "",
      serverId: "",
      status: "",
      currentPage: 1,
      startDate: "",
      endDate: "",
      dateAndTime: "",
      pageSize: 10,
      isWaitAudit: false,
      id: "",
      activityAddress: "",
      btnList: [
        { name: "全部" },
        { name: "已预约" },
        { name: "已付款" },
        { name: "消费中" },
        { name: "服务结束" },
        { name: "取消预约" },
        { name: "已驳回" }
      ],
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: []
      }
    };
  },
  mounted() {
    const { id } = this.$route.query;
    this.$store.dispatch("queryActivityDetails", { id });
    const { storeCode } = getLoginUser();
    this.activityAddress = `http://hx.hemiao100.com/dist/#/activity/activityDetails/${storeCode}/${id}`;
  },
  computed: mapGetters(["activityListDetails"]),
  watch: {},
  methods: {
    switchAuditState(auditState) {
      if (auditState === "reject") {
        this.$confirm("驳回当前促销?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$store
            .dispatch("switchAuditState", {
              id: this.id,
              auditState
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
        });
      } else {
        this.$store
          .dispatch("switchAuditState", {
            id: this.id,
            auditState
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.borderB {
  border-bottom: 1px solid #d8dce5;
}
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    line-height: 30px;
  }
  .content {
    color: #999;
    > div {
      margin-bottom: 10px;
    }
  }
}
</style>
